import ZoomControl from "./ZoomControl";

export default ZoomControl;
